var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGodrejLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 345 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#radial-gradient);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:url(#radial-gradient-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:url(#radial-gradient-3);}.cls-8{clip-path:url(#clip-path-4);}.cls-9{fill:#5db6e2;}.cls-10{clip-path:url(#clip-path-5);}.cls-11{fill:url(#linear-gradient);}.cls-12{clip-path:url(#clip-path-6);}.cls-13{fill:url(#linear-gradient-2);}.cls-14{fill:#0077b8;}.cls-15{fill:#3b81be;}.cls-16{fill:#006ca7;}.cls-17{clip-path:url(#clip-path-8);}.cls-18{fill:url(#linear-gradient-3);}.cls-19{clip-path:url(#clip-path-9);}.cls-20{fill:url(#linear-gradient-4);}.cls-21{clip-path:url(#clip-path-10);}.cls-22{fill:url(#linear-gradient-5);}.cls-23{clip-path:url(#clip-path-11);}.cls-24{fill:url(#linear-gradient-6);}.cls-25{clip-path:url(#clip-path-12);}.cls-26{fill:url(#linear-gradient-7);}.cls-27{fill:#76bee5;}.cls-28{fill:#0070ad;}.cls-29{clip-path:url(#clip-path-14);}.cls-30{fill:url(#linear-gradient-8);}.cls-31{clip-path:url(#clip-path-15);}.cls-32{fill:url(#linear-gradient-9);}.cls-33{clip-path:url(#clip-path-16);}.cls-34{fill:url(#linear-gradient-10);}.cls-35{clip-path:url(#clip-path-17);}.cls-36{fill:url(#linear-gradient-11);}.cls-37{clip-path:url(#clip-path-18);}.cls-38{fill:url(#linear-gradient-12);}.cls-39{clip-path:url(#clip-path-19);}.cls-40{fill:url(#linear-gradient-13);}.cls-41{clip-path:url(#clip-path-20);}.cls-42{fill:url(#linear-gradient-14);}.cls-43{clip-path:url(#clip-path-21);}.cls-44{fill:url(#linear-gradient-15);}.cls-45{fill:#af1e56;}.cls-46{clip-path:url(#clip-path-23);}.cls-47{fill:url(#linear-gradient-16);}.cls-48{clip-path:url(#clip-path-24);}.cls-49{fill:url(#linear-gradient-17);}.cls-50{clip-path:url(#clip-path-25);}.cls-51{fill:url(#linear-gradient-18);}.cls-52{clip-path:url(#clip-path-26);}.cls-53{fill:url(#linear-gradient-19);}.cls-54{clip-path:url(#clip-path-27);}.cls-55{fill:url(#linear-gradient-20);}.cls-56{clip-path:url(#clip-path-28);}.cls-57{fill:url(#linear-gradient-21);}.cls-58{clip-path:url(#clip-path-29);}.cls-59{fill:url(#linear-gradient-22);}.cls-60{clip-path:url(#clip-path-30);}.cls-61{fill:url(#linear-gradient-23);}.cls-62{clip-path:url(#clip-path-31);}.cls-63{fill:url(#linear-gradient-24);}.cls-64{clip-path:url(#clip-path-32);}.cls-65{fill:url(#linear-gradient-25);}.cls-66{clip-path:url(#clip-path-33);}.cls-67{fill:url(#linear-gradient-26);}.cls-68{clip-path:url(#clip-path-34);}.cls-69{fill:url(#linear-gradient-27);}.cls-70{clip-path:url(#clip-path-35);}.cls-71{fill:url(#linear-gradient-28);}.cls-72{clip-path:url(#clip-path-36);}.cls-73{fill:url(#linear-gradient-29);}.cls-74{clip-path:url(#clip-path-37);}.cls-75{fill:url(#linear-gradient-30);}.cls-76{clip-path:url(#clip-path-38);}.cls-77{fill:url(#linear-gradient-31);}.cls-78{clip-path:url(#clip-path-39);}.cls-79{fill:url(#linear-gradient-32);}.cls-80{clip-path:url(#clip-path-40);}.cls-81{fill:url(#linear-gradient-33);}.cls-82{clip-path:url(#clip-path-41);}.cls-83{fill:url(#linear-gradient-34);}.cls-84{clip-path:url(#clip-path-42);}.cls-85{fill:url(#linear-gradient-35);}.cls-86{clip-path:url(#clip-path-43);}.cls-87{fill:url(#linear-gradient-36);}.cls-88{fill:#a7bd45;}.cls-89{clip-path:url(#clip-path-45);}.cls-90{fill:url(#linear-gradient-37);}.cls-91{clip-path:url(#clip-path-46);}.cls-92{fill:url(#linear-gradient-38);}.cls-93{clip-path:url(#clip-path-47);}.cls-94{fill:url(#linear-gradient-39);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208,89.35,204,95.12s-1.17,1.31.59,1.31h16.14a2.61,2.61,0,0,0,2-1.31l3.93-5.77c-6,.24-12.23.24-18.7,0m-45.89-4.49c0,5.13,1.75,12.45,14.06,12.45a27,27,0,0,0,18.44-8.67q-16.35-1.19-32.5-4V85m90.83,2.07c0,4.3,1.09,11.18,8.6,11.18,14.89,0,33.38-18.22,34.34-18.42s.71,0,.71.8-2.09,8-23.87,33.38-32.34,35.57-32.34,41.14a7.41,7.41,0,0,0,6.93,7.48c2.29,0,11.77-.47,34.42-36,16-25.3,23.62-41.22,32.17-53.67h0c-15.48,6.48-35,10.74-61.29,14.16M18.18,146.77c0-7.32,26.29-26.5,29.21-26.54.84,0,1,.32,1,.91,0,5.89-19.2,29.13-26.92,29.13A3.22,3.22,0,0,1,18,147.56a2.1,2.1,0,0,1,0-.79M32.2,84.06C32.2,94.76,42.55,96,48,96c14.27,0,20.86-6.37,23.45-6.37s-1.67,6.45-5.93,9.07C30.66,119.19,1.83,136.82,1.16,153.21v1c.33,7,7.26,7.44,12.52,7.44s31.92-3.26,72.52-64a27.89,27.89,0,0,1,8-6.57c3-2.07,12.52-8.91,14.56-8.91s1.84.8,1.75,1.63a33.57,33.57,0,0,0-1.37,7.08,8.25,8.25,0,0,0,8.93,7c12.51,0,21.32-8.52,28.7-16.16-2.42-.48-5.21-1.07-8.34-1.79a17.23,17.23,0,0,1-7.3,4.22c-2.84,0-3.72-1.47-3.84-2.87a8.5,8.5,0,0,1,.75-4c-5.63-1.4-11.89-3.11-18.65-5.1a9,9,0,0,1-5.05,1.67c-.42,0-.67-.43.25-1.75l.83-1.15c-4.84-1.47-10-3.14-15.27-4.9C79.9,75.15,68.05,84.3,61.54,84.3c-2.59,0-5-1.67-5-5.69a54.73,54.73,0,0,1,10.81-21C62,55.45,56.45,53.14,50.65,50.68c-12.52,13-18.53,24.79-18.53,33.18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -2092.44,
    cy: 364.29,
    r: 3.02,
    gradientTransform: "matrix(83.15, 0, 0, -80.33, 174166.94, 29346.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c11f63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b61e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af1e56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.77,79.88c3.13.72,5.93,1.31,8.35,1.79a67.13,67.13,0,0,1,11.31-10.5c-3.72-.2-7.35-.4-11-.72a40.27,40.27,0,0,1-8.68,9.43m60-10c-3.88,6.85-9.38,13.1-16,13.1a3,3,0,0,1-3.42-2.5h0a1.62,1.62,0,0,1,0-.44,18.26,18.26,0,0,1,3.76-9c-6.22.28-12.52.4-18.45.24a78.12,78.12,0,0,0-2.38,13.13q16.16,2.75,32.51,4a69.28,69.28,0,0,0,13.64-19.9c-3.21.44-6.38.84-9.59,1.2m-84.17-1.36a31.91,31.91,0,0,1-5,3.74c6.76,2,13,3.7,18.65,5.1a32.55,32.55,0,0,1,5.47-8.4c-5.59-.76-11.19-1.67-16.69-2.75l-2.47,2.31M90.45,66c5.3,1.83,10.44,3.46,15.28,4.93l4.67-6.17c-5-1.11-9.89-2.27-14.69-3.5L90.45,66M51.15,50.68h0c5.55,2.46,11.06,4.77,16.44,6.88.92-1.23,1.88-2.51,2.88-3.74-5.8-1.91-11.35-4-16.69-5.85-.92.92-1.84,1.79-2.67,2.71M277.05,65c0-2.94,10.18-12.41,13.6-12.41a1.09,1.09,0,0,1,1.13.95c0,3.74-10.14,12.65-13.39,12.65a1.27,1.27,0,0,1-1.34-1.11h0m33.09-8c-10.22,10.67-22.49,25-33.38,25a4.8,4.8,0,0,1-5.34-4,3.86,3.86,0,0,1,0-.68c0-1.87,1.46-3.54,4.17-4.37,10.43-3,26.83-16.16,26.83-25,0-2.35-1.21-4.89-4.17-4.89-4.51,0-17.11,2-32.84,20.17a8.37,8.37,0,0,1-5.05,3.42c-1.46,0-3.17-2.7-3.17-8V57.24a263.39,263.39,0,0,1-35,9.11c-3.83,7.28-10,16.48-14.39,22.92,6.47.2,12.52.2,18.69,0,4.17-6,9.85-14.56,10.14-15a2.23,2.23,0,0,1,1.84-1.11c2.54,0-.59,6.24,8.88,6.24a29.44,29.44,0,0,0,6-1.31c.67,0,.75.6.75,1.08a45.51,45.51,0,0,0-1.33,6.32v1.43c26.33-3.42,45.9-7.67,61.29-14.16A107.57,107.57,0,0,1,326.12,57.6c6.76-6.33,8.35-9.71,8.35-11.18a3.58,3.58,0,0,0-3.2-4h-.43c-2.42,0-10.56,4-20.87,14.56m19.11-21.48c0,2.66,4.18,4.53,5.64,4.53a12.77,12.77,0,0,0,9.3-10.3V29a4.46,4.46,0,0,0-4.17-4.46c-3.38,0-10.89,7.37-10.89,11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -2054.98,
    cy: 349.02,
    r: 3.02,
    gradientTransform: "matrix(35.32, 0, 0, -34.12, 72787.27, 11972.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3396ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077b8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.9,48.65c-1.88,1.75-7,6.88-13.27,12.73,4.8,1.23,9.72,2.43,14.69,3.5,4.46-5.93,10.26-13.53,11.8-15.2,2.51-2.78,3.8-4,3.8-5s-1.54-2-3.46-2a23,23,0,0,0-13.56,5.93M171.49,23a5.42,5.42,0,0,1,5.21-5.65,5,5,0,0,1,1.09,0c16.69,0,25,23,25,24.39,0,.72-.46,1.16-1.67,1.16-6.09,0-29.21-8.8-29.21-19.9m-13.85-3.74c0,8,5,19,25.87,25.71.5,0,1,.23,1,.63s-9.88,13.73-18.77,15.24a1.57,1.57,0,0,1-1.71-1.31v-.28a31.93,31.93,0,0,0,1.37-7.68c0-4-1.29-9.87-9.34-9.87s-16.69,3.58-39.14,24.51c5.51,1.08,11.1,2,16.69,2.75,7-8.2,17.73-16.27,20.44-16.31,1.63,0,2.34.63,2.42,1.31.25,2.9-4.17,4.93-6.71,6.8s-4.18,2.83-3.8,4.66c0,1,1.67,1.27,1.84,3.06a3.87,3.87,0,0,1-.59,2c3.63.32,7.26.52,11,.72a8.12,8.12,0,0,1,4.59-1.51c1.25,0,1.75.51,1.75,1.31v.36c6.09,0,12.22,0,18.44-.24a43.28,43.28,0,0,1,9.76-10.86c3.59-2.07,5.55-4,5.51-5.3s-2.58-2.74-2.84-4,.84-2.06,3.3-1.43c3.55.84,6.13,1,6.22,3.46a49.23,49.23,0,0,1-6.76,16.84c3.21-.36,6.38-.76,9.6-1.2A45,45,0,0,0,213,52.71a1.45,1.45,0,0,1,1.63-1.64c1.38,0,5.22.4,6.93.56a4.67,4.67,0,0,1,4.17,5,25.66,25.66,0,0,1-3.55,9.75,261.47,261.47,0,0,0,34.89-9.43C257.61,50,261,47.1,261.28,45v-.4c0-1.43-.75-2-2.59-2-4.42,0-13.06,10.19-14.6,10.19s-2.71-4.66-4.17-6.53c-2-2.67-4.93-3.3-13-3.3-4.18,0-6.43.32-10.06.32s-5.09,0-5.84-1.91S198.11,8.78,170.53,8.78C164.39,8.78,158,11.36,158,19.4M74.56,31.34A166.45,166.45,0,0,0,54,48.13h0c5.29,2,10.89,4,16.69,5.85a96.49,96.49,0,0,1,10.93-11.5c16.31-14.52,35.26-21.61,47-21.61a81.77,81.77,0,0,1,11.69,1c.62,0,.83,0,1.08-.44l9-15.92a.33.33,0,0,0,0-.47h0a14.82,14.82,0,0,0-5-.6c-13.19,0-41.73,6.33-70.94,26.66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -2068.8,
    cy: 354.83,
    r: 3.02,
    gradientTransform: "matrix(44.8, 0, 0, -43.29, 92894.33, 15417.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5be46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8ab23f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa642"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.49,
    y: 3.92,
    width: 344.49,
    height: 159.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.2,73.83,232.7,79c-2,3-4.76,7.08-6.93,10.3h2.09c1.79-2.66,4.17-5.93,6.3-9.39l3.5-5.17a1.69,1.69,0,0,1,1.17-.76s.29,0,.58,1.12c.55,1.91,1.47,5.13,8.35,5.13a17.55,17.55,0,0,0,5-1l1-.28v.28a5.06,5.06,0,0,1-.38,1.47,20.1,20.1,0,0,0-1.13,5v1.59l1.59-.2V85.85a19,19,0,0,1,1-4.62,6.24,6.24,0,0,0,.46-2c0-1.67-1.08-1.83-1.54-1.83a5.4,5.4,0,0,0-1.59.36,13.88,13.88,0,0,1-4.42,1c-5.59,0-6.22-2.23-6.76-4-.25-1-.63-2.23-2.09-2.23a3.06,3.06,0,0,0-2.5,1.47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1539.78,
    y1: 559.74,
    x2: -1536.82,
    y2: 559.74,
    gradientTransform: "matrix(3.2, 2.72, 2.69, -3.24, 3671.39, 6090.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b81be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#54a7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eb6e3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.81,69.93a36.68,36.68,0,0,1-5.67,7.48,13.75,13.75,0,0,1-9.43,4.86,2.32,2.32,0,0,1-2.63-1.91h0a.86.86,0,0,1,0-.32,18.42,18.42,0,0,1,3.92-9h-2A18.33,18.33,0,0,0,178.5,80a3.78,3.78,0,0,0,3.83,3.74h.34A15.42,15.42,0,0,0,193,78.29a42,42,0,0,0,6.46-8.87h0l-1.92.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2680.76,
    y1: 296.29,
    x2: -2677.78,
    y2: 296.29,
    gradientTransform: "matrix(-3.79, -2.28, -2.25, 3.84, -9304.94, -7173.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#87c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#7ebfe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#64b0db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3b99cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0278b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077b8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.5,47.93c0,8.67-16.35,21.49-26.2,24.31a5.64,5.64,0,0,0-4.88,5.17H272c0-1.63,1.38-3,3.76-3.62,10.18-2.9,26.95-15.91,27.33-25.42V48Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1906.17,
    y1: 289.87,
    x2: -1903.21,
    y2: 289.87,
    gradientTransform: "matrix(11.08, 0, 0, -11.23, 21393.39, 3317.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006ca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066a0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.62,62.73a8,8,0,0,1-4.47,3.11c-.79,0-2.38-2.19-2.38-7.25a15.22,15.22,0,0,1,0-1.91l-1.62.56v1.35c0,6,2,8.8,4.17,8.8s4.51-2.31,5.67-3.7c2-2.31,4.18-4.38,5.85-6.17L271.17,56a90,90,0,0,0-6.39,6.72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2846.77,
    y1: 780.83,
    x2: -2843.8,
    y2: 780.83,
    gradientTransform: "matrix(-3.05, 0.4, 0.39, 3.09, -8700.83, -1215.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#54b0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3a9ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1082bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077b8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271,56l.67,1.51C284.85,44.87,295,43.79,298,43.79s3.5,3.38,3.5,4h1.63a5.15,5.15,0,0,0-4.63-5.61H298c-4.17,0-14.1,1.47-27,13.77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -809.71,
    y1: -18.26,
    x2: -806.74,
    y2: -18.26,
    gradientTransform: "matrix(1.87, 0.16, 0.16, -1.9, 1823.54, 146.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#52acda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3291c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066a0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.93,65.2c0-2.59,9.93-11.62,12.81-11.62h.33c0,3.3-9.76,11.94-12.52,11.94,0,0-.54,0-.54-.44m-1.58,0a2,2,0,0,0,2,2h0c3.71,0,14.19-9.19,14.19-13.41a1.85,1.85,0,0,0-1.92-1.71c-3.76,0-14.4,9.75-14.4,13.17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3581.92,
    y1: -450.41,
    x2: -3579.04,
    y2: -450.41,
    gradientTransform: "matrix(-0.95, -1.2, -1.19, 0.96, -3654.21, -3806.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57a9d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4da2cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3390c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0972ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006ca7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330,35.79c0-3,7.1-10.14,10.1-10.14,1.92,0,3.26,2.07,3.26,4a12.1,12.1,0,0,1-8.35,9.91c-1.17,0-4.8-1.68-4.8-3.75m-1.58,0c0,3.19,4.54,5.3,6.38,5.3A13.34,13.34,0,0,0,345,29.67a5.28,5.28,0,0,0-4.84-5.53c-3.92,0-11.68,8-11.68,11.69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -423.39,
    y1: 416.55,
    x2: -420.43,
    y2: 416.55,
    gradientTransform: "matrix(1.41, 0.59, 0.59, -1.42, 694.91, 876.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#51abd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2f8cbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006298"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.56,56.76l-3.18,3.31c-9.47,10.06-20.11,21.32-29.79,21.32a4.11,4.11,0,0,1-4.5-3.62,1.09,1.09,0,0,1,0-.36H270.5a5.32,5.32,0,0,0,5,5.69h.29a19.42,19.42,0,0,0,9.43-2.34,92.76,92.76,0,0,0,22.4-19.62l3.18-3.34c10.22-10.67,18.1-14.25,20.15-14.25V42h0c-2.8,0-11.06,4-21.32,14.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2431.22,
    y1: 755.96,
    x2: -2428.24,
    y2: 755.96,
    gradientTransform: "matrix(-4.57, 2.61, 2.58, 4.63, -12726.29, 2888.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#53addc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3596c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0671ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006ca7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.71,43.51a2.82,2.82,0,0,1,2.88,2.75h0v.32c0,.12-.58,3.42-8.35,10.62a110.59,110.59,0,0,0-12.51,16.24l2.67-1.12A108.39,108.39,0,0,1,326.54,58.4c5.71-5.38,8.72-9.43,8.72-11.74a4.32,4.32,0,0,0-4.11-4.57h-.44Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 209.32,
    y1: 1996.95,
    x2: 212.23,
    y2: 1996.95,
    gradientTransform: "matrix(0.5, 0.77, 0.76, -0.51, -1297.15, 916.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4aa4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2280b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#096a9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006298"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.71,81.39A4.12,4.12,0,0,0,131.26,85h0a18.5,18.5,0,0,0,8.35-4.81l-1.92-.44a15.19,15.19,0,0,1-6.39,3.66c-1.87,0-2.88-.67-3-2.19a8,8,0,0,1,.71-3.54l-1.55-.43a9.51,9.51,0,0,0-.75,4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1603.34,
    y1: 156.01,
    x2: -1600.42,
    y2: 156.01,
    gradientTransform: "matrix(4.38, 0, 0, -4.43, 7140.44, 772.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af1e56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#b02158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c54775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d25f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7688e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.18,71.76c-.75,1-1,1.72-.71,2.31a1.48,1.48,0,0,0,1,.68,11.13,11.13,0,0,0,6.14-2.19l-2-.6a9.38,9.38,0,0,1-3.42,1.24.65.65,0,0,1,.34-.56l1-1.31-1.58-.48-.67.91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1201.7,
    y1: -15.53,
    x2: -1198.74,
    y2: -15.53,
    gradientTransform: "matrix(2.45, 0, 0, -2.48, 3041.51, 34.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a61d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ab2356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d25281"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.23,146.69c0-6.77,25.62-25.71,28.62-25.75h.25c0,3.31-7.38,13.73-14.89,21-4.8,4.66-8.89,7.33-11.23,7.33s-2.75-.64-2.75-2.59m28.62-27.3c-2.08,0-10.14,5.57-16.4,10.71-5.34,4.25-13.68,11.85-13.68,16.59A4,4,0,0,0,21.58,151h.36c3.59,0,8.68-4.26,12.52-8,7.13-6.89,15.23-17.91,15.23-21.89a1.64,1.64,0,0,0-.46-1.27,2.26,2.26,0,0,0-1.34-.44h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -997.27,
    y1: 1049.56,
    x2: -994.34,
    y2: 1049.56,
    gradientTransform: "matrix(1.05, 1.54, 1.52, -1.07, -516.3, 2791.66)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,78.73c0,4.77,3.13,6.44,5.8,6.44,6.63,0,17.9-8.43,29.45-18.74l-1.66-.55C79.44,74.79,68,83.62,61.75,83.62c-2.63,0-4.18-1.83-4.18-4.89A53.81,53.81,0,0,1,68.34,58l-1.54-.52C59.62,67.23,56,75.94,56,78.81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1687.03,
    y1: 486.82,
    x2: -1684.09,
    y2: 486.82,
    gradientTransform: "matrix(4.29, 3.34, 3.29, -4.35, 5695.14, 7812.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a61d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c04470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d15e86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7688e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.49,153.89H2.08c0-15.64,26.62-32.35,64.17-54.31l-.83-1.32C27.57,120.43.49,137.46.49,154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1832.36,
    y1: -35.62,
    x2: -1829.38,
    y2: -35.62,
    gradientTransform: "matrix(4.14, -2.53, -2.5, -4.19, 7547.43, -4669.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7688e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d36088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b93164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af1e56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.75,84c0,8,6,12.77,16.69,12.77V95.32c-5.6,0-15-1.51-15-11.3,0-7.64,5.21-19.3,18.48-32.87l-1.5-.67C37,64.24,31.75,76.14,31.75,84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -918.57,
    y1: 1081.03,
    x2: -915.69,
    y2: 1081.03,
    gradientTransform: "matrix(1.02, 1.42, 1.41, -1.03, -535.17, 2505.9)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.28,97a7.49,7.49,0,0,1-8.34-6.17h-1.59a9.07,9.07,0,0,0,9.56,7.72c12.85,0,22.11-8.91,29.62-16.71l-1.62-.48c-7.18,7.44-16,15.56-27.79,15.56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3374.98,
    y1: 386.69,
    x2: -3372,
    y2: 386.69,
    gradientTransform: "matrix(-1.82, -0.77, -0.76, 1.84, -5711.73, -3216.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a61d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ad295a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c6577e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d57394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db7d9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.63,90l-.71.48-1.84,1.23a21.63,21.63,0,0,0-6.38,5.65C45.22,157.91,18.94,161,13.85,161c-7.06,0-11.77-1.27-11.77-7.24H.49c0,8.79,9,8.79,13.36,8.79,2.92,0,11.09-.91,23.53-9.43,15.69-10.66,32.38-29.16,49.65-55A21.19,21.19,0,0,1,92.87,93l1.88-1.23.71-.48c9.81-6.88,12.52-8.2,13.39-8.31s.88,0,.92,0l1.13-1.12c-.5-.48-1-.56-2.05-.56s-5.46,2.43-14.35,8.56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -880.33,
    y1: 482.14,
    x2: -877.36,
    y2: 482.14,
    gradientTransform: "matrix(1.7, 0.95, 0.94, -1.72, 1077.12, 1775.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7688e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ca547d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b02c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a61d50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.39,84.82c0,8.63,5.13,13.25,14.85,13.25a28.46,28.46,0,0,0,19.4-9.39h-2a26.1,26.1,0,0,1-17.36,7.95c-8.93,0-13.27-4-13.27-11.69v-.36l-1.58-.28v.48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -2852.63,
    y1: 622.59,
    x2: -2849.7,
    y2: 622.59,
    gradientTransform: "matrix(-3.22, -0.24, -0.23, 3.26, -8862.1, -2622.95)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.69,89.35l-3.47,5.37c-.54.72-1,1-1.29,1H204.78l2.71-4L209,89.47h-1.84l-1,1.47-2.67,4a2.1,2.1,0,0,0-.5,1.24,1.1,1.1,0,0,0,0,.51c0,.36.58.76,1.63.76h16.31a3.52,3.52,0,0,0,2.59-1.63l4.5-6.33h-2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -2883,
    y1: -1.72,
    x2: -2880.09,
    y2: -1.72,
    gradientTransform: "matrix(-1.94, -2.26, -2.23, 1.97, -5382.59, -6420.14)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.89,87.16h0a13.18,13.18,0,0,0,3,9.27,8.52,8.52,0,0,0,6.43,2.47h0V97.39a7.11,7.11,0,0,1-5.26-2,12.4,12.4,0,0,1-2.54-8.52l-1.59.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -4015.54,
    y1: -409.2,
    x2: -4012.59,
    y2: -409.2,
    gradientTransform: "matrix(-0.88, -0.89, -0.88, 0.89, -3629.19, -3108.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be356e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c13971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ca4579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d24f80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.48,82.47l-.58.56a.49.49,0,0,1,0,.47,1.52,1.52,0,0,1,0,.6,3.78,3.78,0,0,1-.38,1.51,16.94,16.94,0,0,0-1,5.17h1.59a16.6,16.6,0,0,1,.87-4.73,9,9,0,0,0,.51-2v-.4A2,2,0,0,0,111,82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -2796.89,
    y1: -650.47,
    x2: -2794.05,
    y2: -650.47,
    gradientTransform: "matrix(-0.35, -2, -1.97, 0.36, -2148.19, -5261.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c25078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ae2b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a61d50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.84,113.54c-5.8,6.81-10.69,12.38-15,17.31-12,13.73-17.48,19.9-17.48,24.31a8.25,8.25,0,0,0,1.75,5.18l1-1.28a6.75,6.75,0,0,1-1.17-4c0-3.78,5.71-10.3,17.1-23.31,4.18-4.9,9.23-10.51,15-17.31,7.8-9.11,13-15.92,16.69-20.85l-1.67-.44c-3.51,4.9-8.64,11.5-16.15,20.29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -2049.23,
    y1: 138.13,
    x2: -2046.29,
    y2: 138.13,
    gradientTransform: "matrix(6.5, -8.15, -8.05, -6.59, 14710.4, -15681.72)",
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.69,73.44c-4.18,6-6.56,10.7-11.48,19.13-5.63,9.67-12,20.58-20.28,33.59-19.78,31-29.62,35.81-33.75,35.81a7,7,0,0,1-5.09-2.79l-1,1.24a8.51,8.51,0,0,0,6.1,3.1c7.8,0,19.94-12.61,35.13-36.45,8.34-13,14.69-23.87,20.32-33.66s8.34-14.64,12.52-21h0l-2.67,1.12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -496.7,
    y1: 277.12,
    x2: -493.7,
    y2: 277.12,
    gradientTransform: "matrix(1.48, 0.52, 0.51, -1.5, 849.32, 783.87)",
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.49,79.13c-.33,0-.62.27-2.46,1.83-5.42,4.41-19.82,16.55-31.79,16.55V99c12.52,0,27.24-12.29,32.79-16.91l1.38-1.15A55.19,55.19,0,0,1,288,93.33l1.67.44c6.8-9.51,7.43-12.58,7.47-13v-.28a1.13,1.13,0,0,0-.46-1,1.08,1.08,0,0,0-.83-.27h-.34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -1925.64,
    y1: 296,
    x2: -1922.68,
    y2: 296,
    gradientTransform: "matrix(12.14, 0, 0, -12.3, 23636.57, 3729.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be356e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b72e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a61d50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.33,52.75a45.12,45.12,0,0,1-4.92,15.91l1.84-.28a43.2,43.2,0,0,0,4.67-15.91c0-.68.21-.88.83-.88s4.18.32,6.06.52h.79a4,4,0,0,1,3.54,4A26.77,26.77,0,0,1,221.35,66l2-.4a25,25,0,0,0,3.38-9.51,5.57,5.57,0,0,0-5-5.65H221c-2-.2-5-.48-6.22-.48a2.21,2.21,0,0,0-2.41,2h0v.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 196.56,
    y1: 1039.99,
    x2: 199.5,
    y2: 1039.99,
    gradientTransform: "matrix(0.82, 0.65, 0.64, -0.83, -614.34, 791.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8bb244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.36,23a4.61,4.61,0,0,1,4.4-4.85h0a2.86,2.86,0,0,1,1,0C193.64,18.17,201.9,40.29,202,42c0,0,0,.32-.88.32-5.59,0-28.58-8.59-28.58-19.22m-1.59,0c0,11.94,23.87,20.77,30.17,20.77,2.13,0,2.46-1.23,2.46-1.91,0-1.51-8.34-25.18-25.82-25.18A6.22,6.22,0,0,0,171,22.3h0v.87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -1028.55,
    y1: -615.87,
    x2: -1025.58,
    y2: -615.87,
    gradientTransform: "matrix(1.58, -0.59, -0.59, -1.6, 1450.16, -1562.5)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.92,71.09h2.72a7,7,0,0,1,3.08-.84c1,0,1,.32,1,.56v.36h1.46v-.36a2.2,2.2,0,0,0-2.27-2.13l-.27,0a10.82,10.82,0,0,0-5.93,2.23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 854.01,
    y1: 674.75,
    x2: 856.98,
    y2: 674.75,
    gradientTransform: "matrix(0.73, 0.4, 0.39, -0.74, -729.83, 225.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7bab43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9ab945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.19,49.24a2.09,2.09,0,0,0-.55,1.95,5.2,5.2,0,0,0,1.59,2.15c.46.52,1.25,1.24,1.25,1.55a11.54,11.54,0,0,1-5.13,4.66A44.39,44.39,0,0,0,182,71.13h2A41.85,41.85,0,0,1,193,61c3.75-2.19,5.92-4.42,5.88-6,0-.91-.84-1.71-1.67-2.58s-1.13-1.12-1.17-1.44a.66.66,0,0,1,0-.55c0-.2,1-.32,2.3,0l1.58.36c3,.67,4.17,1,4.17,2.42a48.72,48.72,0,0,1-6.34,16.87l1.92-.2a47.79,47.79,0,0,0,6-16.71c0-2.74-2.46-3.26-5.26-4l-1.54-.35a5.2,5.2,0,0,0-1.79-.28,2.6,2.6,0,0,0-2,.67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 263.57,
    y1: 543.49,
    x2: 266.55,
    y2: 543.49,
    gradientTransform: "matrix(0.94, 0.47, 0.47, -0.95, -303.23, 455.33)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.31,48.05l-2.88,2.83c-2.58,2.54-6.38,6.24-10.72,10.22l1.79.48c3.43-3.14,6.81-6.45,10.06-9.63l2.88-2.79a22.65,22.65,0,0,1,13-5.69c1.54,0,2.67.64,2.67,1.16h1.58c0-1.67-2.12-2.71-4.17-2.71a24.24,24.24,0,0,0-14.14,6.13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -3317.94,
    y1: 553.86,
    x2: -3314.96,
    y2: 553.86,
    gradientTransform: "matrix(-1.96, -0.5, -0.49, 1.99, -6114.39, -2707.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#76a942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#88b144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.13,44.67a14.18,14.18,0,0,1-3,4l-.62.67c-1.59,1.75-7.51,9.55-12,15.52h0l1.67.36h0c4.46-5.85,10.06-13.25,11.56-14.88l.83-.76c2.3-2.54,3.38-3.7,3.38-4.81Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1733.06,
    y1: 213.78,
    x2: -1730.1,
    y2: 213.78,
    gradientTransform: "matrix(5.84, 0, 0, -5.92, 10232.03, 1320.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#639440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#639440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6fa542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6fa642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa642"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.41,5.79c-3.17,5.38-8.63,14.81-8.89,15.24h-.58a72.92,72.92,0,0,0-11.43-1,64.75,64.75,0,0,0-28.58,8.55l.7,1.36a63,63,0,0,1,27.79-8.2,71.55,71.55,0,0,1,11.23,1h.58a2.33,2.33,0,0,0,1.05,0,1.71,1.71,0,0,0,.79-.71c.37-.6,8.84-15.12,9.18-15.72a1,1,0,0,0,0-.95Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -2080.74,
    y1: -1689.04,
    x2: -2077.89,
    y2: -1689.04,
    gradientTransform: "matrix(0.47, -1.11, -1.09, -0.47, -734.54, -3092.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6aa042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6da242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#76a643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#87af44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9dba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a5be46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.86,41.92A93.81,93.81,0,0,0,69.63,53.86h0l1.63.48h0A92.14,92.14,0,0,1,100.43,30l-.71-1.36a98.19,98.19,0,0,0-19,13.29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -1906.16,
    y1: 286.25,
    x2: -1903.2,
    y2: 286.25,
    gradientTransform: "matrix(10.47, 0, 0, -10.61, 20033.79, 3078.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#639440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#639440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#659741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6aa042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6aa042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.07,66.07h0l1.84.28h0c21.45-19.89,30.33-23.87,38.18-23.87a7.74,7.74,0,0,1,7.18,3.34,10.35,10.35,0,0,1,1.37,5.77,20.06,20.06,0,0,1-1,5.85,7,7,0,0,0-.33,1.63,2.44,2.44,0,0,0,.83,1.83l1-1.15a.94.94,0,0,1-.29-.72,7.12,7.12,0,0,1,.29-1.19,20.89,20.89,0,0,0,1.09-6.45,12.9,12.9,0,0,0-1-5.61,9,9,0,0,0-9-4.89c-8.35,0-17.7,4.18-40.1,25.11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -1986.63,
    y1: 320.28,
    x2: -1983.67,
    y2: 320.28,
    gradientTransform: "matrix(17.01, 0, 0, -17.23, 33910.74, 5572.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5be46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#a2bd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9ab845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8baf44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#76a442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#669b41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.67,45.82c-1.38,2.19-10.06,12.93-17.94,14.29a.62.62,0,0,1-.5,0l-1,1.15a2.46,2.46,0,0,0,1.8.48c9.26-1.59,19.44-14.61,19.44-15.92Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -1913.32,
    y1: -45.26,
    x2: -1910.35,
    y2: -45.26,
    gradientTransform: "matrix(3.97, -3.55, -3.51, -4.02, 7607.27, -6916.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#669b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#669b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#71a040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#88a93f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#95af3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9ab13e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#96b03e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8aab3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#76a441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6aa042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.47,48.93A35.47,35.47,0,0,1,244,51.87a13.59,13.59,0,0,1-1.79-3,22.59,22.59,0,0,0-1.8-3.27c-2.21-2.86-5.17-3.66-13.68-3.66h-5.38v1.55h5.3c8,0,10.51.64,12.51,3a19.32,19.32,0,0,1,1.63,2.86c1,2.19,1.92,4,3.17,4s1.8-.79,4.63-3.42,7.51-6.8,10-6.8c1.62,0,1.79.43,1.79,1.47a7.24,7.24,0,0,1-1.09,2.74,21.42,21.42,0,0,0-3,9.83l1.63-.56a19.81,19.81,0,0,1,2.75-8.51A8.31,8.31,0,0,0,262,44.63a2.83,2.83,0,0,0-.63-2,3.31,3.31,0,0,0-2.79-1c-3.09,0-7.52,4-11.06,7.21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -2391.15,
    y1: 399.74,
    x2: -2388.22,
    y2: 399.74,
    gradientTransform: "matrix(-8.85, -2.73, -2.7, 8.97, -19843.56, -10064.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#669b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#72a242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#93b445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a5be46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6a9d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7da843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.08,41.6C211,43.71,212.5,44,215.84,44h5.59V42.48h-4.67c-4.17,0-4.59,0-5.13-1.47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -1515.07,
    y1: 132.69,
    x2: -1512.11,
    y2: 132.69,
    gradientTransform: "matrix(3.85, 0, 0, -3.9, 6050.56, 559.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#76a943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8bb244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.13,51.87c-2.8,0-11.64,6.68-18.28,13.61l-.87.91c-.71.8-1.47,1.55-2.17,2.47l1.87.28a11.7,11.7,0,0,1,1.51-1.71c.54-.6,1.08-1.2,1.66-1.75,6.76-6.85,14.44-11.94,16.32-11.94,1,0,1.58.24,1.63.64h0c0,1.83-2.51,3.42-4.72,4.81l-1.67,1.08h0c-2.79,1.95-4.17,2.9-4.17,4.65v.72a2.51,2.51,0,0,0,1,1.51A2.43,2.43,0,0,1,147,68.3h1.55a3.45,3.45,0,0,0-1.34-2.23,2.36,2.36,0,0,1-.5-.63c0-1.28.25-1.63,3.42-4h0l1.59-1c2.67-1.71,5.67-3.62,5.46-6.4,0-1-1-2.07-3.08-2.07h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -1403.11,
    y1: 795.12,
    x2: -1400.17,
    y2: 795.12,
    gradientTransform: "matrix(1.79, 2.4, 2.37, -1.81, 768.84, 4862.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#669b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#93b445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#a5be46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5be46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.12,68.18v.36h0a3.35,3.35,0,0,1-.67,1.71h1.71a3.83,3.83,0,0,0,.54-2.11v-.23Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -1406.52,
    y1: 796.74,
    x2: -1403.62,
    y2: 796.74,
    gradientTransform: "matrix(1.79, 2.4, 2.36, -1.81, 766.77, 4862.71)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.84,14.63a12.42,12.42,0,0,0-.92,4.77c0,6.69,3.47,19,26.42,26.42h2c0-.91-.88-1.15-1.38-1.31h0c-22-7.12-25.32-18.7-25.32-25a10.82,10.82,0,0,1,.83-4.34,11.56,11.56,0,0,1,11-5.53c24.2,0,36.42,24.35,39.59,31.83v.28l1.46-.59v-.28c-3.25-7.68-15.85-32.75-41.05-32.75A12.64,12.64,0,0,0,158,14.75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -3290.32,
    y1: -252.05,
    x2: -3287.36,
    y2: -252.05,
    gradientTransform: "matrix(-1.2, -1.45, -1.43, 1.22, -4133.12, -4446.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#84b049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#aec458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aec458"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "white godrej logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.29,
    y: 50.84,
    width: 312.69,
    height: 111.85
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 51.11,
    y: 24.85,
    width: 293.08,
    height: 64.62
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 53.78,
    y: 4.68,
    width: 207.34,
    height: 66.81
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114,67.94a27,27,0,0,1-5.43,4l2,.6a38.51,38.51,0,0,0,4.59-3.42c1-1,1.92-1.83,2.83-2.67l-1.91-.36-2.05,1.87"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "237.83 58.4 263.66 79.36 242.92 103.24 217.05 82.31 237.83 58.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "194.14 92.85 172.03 80.12 183.96 60.7 206.08 73.44 194.14 92.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M127.46,77.18l1.55.39a31.65,31.65,0,0,1,5.59-8.43l-1.88-.28a33.53,33.53,0,0,0-5.34,8.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M89.54,65.84l1.66.59,5.3-4.93L94.71,61c-1.63,1.55-3.38,3.18-5.17,4.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.45,70.33a24.91,24.91,0,0,1-3,4,56.4,56.4,0,0,1-5.8,5.45l1.92.44c1.79-1.55,3.5-3.18,5.09-4.85a21.91,21.91,0,0,0,3.46-4.74h-1.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M148.12,79.36l-2.05,2,1.84.4,1.38-1.43a42.9,42.9,0,0,1,10.35-9.23h-2.8A61.71,61.71,0,0,0,148,79.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M66.8,57.52l1.5.64c.92-1.28,1.92-2.55,3-4l-1.63-.64c-1,1.23-2,2.47-2.83,3.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 270.46,
    y: 47.93,
    width: 32.71,
    height: 29.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "273.13 67.19 256.44 69.26 254.69 56.21 271.42 54.14 273.13 67.19"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "271.21 39.69 304.46 42.4 302.92 60.15 269.67 57.44 271.21 39.69"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "282.64 74.87 268.62 57.96 286.23 44.35 300.21 61.26 282.64 74.87"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "330.88 18.41 351.24 26.6 342.56 46.78 322.2 38.54 330.88 18.41"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M207,89.35h1.84a247.46,247.46,0,0,0,14.44-23l-2,.4c-3.93,7.32-10.14,16.59-14.32,22.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.31,50.44l1.51.67,2.75-2.78L53,47.77c-.91.88-1.83,1.79-2.67,2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M109.56,64.68l-4.63,6.13,1.59.52L111.11,65l-1.67-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.39,72.92a57.86,57.86,0,0,0-2,11.38l1.58.28a59.22,59.22,0,0,1,2-11.14c.25-1,.38-1.56.46-2h-1.58a2.88,2.88,0,0,1-.38,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M207.41,68.82A74.82,74.82,0,0,1,202,78.37a58,58,0,0,1-8.35,10.11h2a71.5,71.5,0,0,0,13.6-19.9l-1.84.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "349.11 73.16 285.02 108.09 252.22 51.91 316.27 16.97 349.11 73.16"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "328.33 31.86 350.36 63.77 319.65 83.54 297.66 51.63 328.33 31.86"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 126.63,
    y: 77.18,
    width: 13.02,
    height: 7.76
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 103.22,
    y: 70.85,
    width: 7.39,
    height: 4.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "39.17 104.91 64.88 140.8 27.91 165.51 2.2 129.66 39.17 104.91"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "69.01 40.97 105.1 67.71 78.14 101.61 42.09 74.91 69.01 40.97"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "-25 112.99 48.69 70.01 91.75 138.89 18.06 181.86 -25 112.99"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "44.93 41.29 74.6 80.96 38.63 106.06 8.96 66.35 44.93 41.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M66.25,99.42C69.8,97.27,74,92.14,73.39,90a1.51,1.51,0,0,0-1.63-1,11,11,0,0,0-4.17,1.48,40.55,40.55,0,0,1-19.15,4.89v1.47a41.07,41.07,0,0,0,20.11-5,12.79,12.79,0,0,1,3.34-1.35h0a15.48,15.48,0,0,1-6.47,7.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "142.03 112.15 102.26 96 114.45 67.94 154.21 84.02 142.03 112.15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "26.28 36.19 146.53 100.29 85.24 207.65 -35.02 143.54 26.28 36.19"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "195.44 100.45 160.34 97.99 161.56 81.91 196.65 84.38 195.44 100.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "213.5 109.01 198.77 92.61 217.01 77.38 231.7 93.77 213.5 109.01"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "256.61 103.6 245.63 93.01 256.61 82.47 267.54 93.01 256.61 103.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "108.65 91.34 106.98 82.19 111.48 81.43 113.15 90.58 108.65 91.34"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "205.41 133.88 259.19 69.5 323.58 119.75 269.79 184.09 205.41 133.88"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "249.05 50.08 344.56 82.11 307.39 185.64 211.88 153.65 249.05 50.08"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 261.28,
    y: 79.09,
    width: 35.84,
    height: 19.93
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "214.8 41.29 236.03 57.4 219.34 77.89 198.11 61.78 214.8 41.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "161.64 19.96 199.48 6.39 212.54 40.49 174.7 54.02 161.64 19.96"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "158.88 65.48 166.52 69.42 163.56 74.75 155.92 70.81 158.88 65.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "186.76 39.38 215.13 53.1 201.07 80.32 172.69 66.63 186.76 39.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "124.84 68.9 89.95 60.46 96.59 34.68 131.47 43.12 124.84 68.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 109.48,
    y: 44.67,
    width: 17.23,
    height: 20.41
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "90.54 26.17 107.81 -12.83 160.59 9.02 143.28 48.01 90.54 26.17"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 69.63,
    y: 28.63,
    width: 30.92,
    height: 25.58
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 116.07,
    y: 40.97,
    width: 50.2,
    height: 25.47
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "155.96 52.7 176.12 35.48 193.68 54.66 173.49 71.88 155.96 52.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "258.48 68.18 216.88 55.93 224.81 30.78 266.41 43.04 258.48 68.18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 210.08,
    y: 40.93,
    width: 11.39,
    height: 2.98
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M151.29,5.2a1,1,0,0,0-.71-.64,16.38,16.38,0,0,0-5.21-.64C132.85,3.92,104.14,9.53,74,30.7A166,166,0,0,0,53.15,47.81l1.59.6A173.19,173.19,0,0,1,75,31.94c29.75-20.89,58.41-26.5,70.39-26.5a18.25,18.25,0,0,1,4.17.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "148.62 40.37 166.19 62.85 141.82 80.64 124.21 58.16 148.62 40.37"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "147.91 67.11 149.91 69.7 147.28 71.61 145.32 69.06 147.91 67.11"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "179.5 71.81 137.6 23.54 188.97 -18.08 230.86 30.14 179.5 71.81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodrejLogo);
export default __webpack_public_path__ + "static/media/godrej-logo.f491cf8db707d1c4d7aab52adc92b754.svg";
export { ForwardRef as ReactComponent };